import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _SessionItemResultsList;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import CustomPropTypes from '../../../../util/CustomPropTypes';
import SessionItemResult from '../SessionItemResult';
import ResultStimulus from '../ResultStimulus';
import generateDisplayPositions from '../../../../util/generateDisplayPositions';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var SessionItemResultsList = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_SessionItemResultsList = /*#__PURE__*/function (_Component) {
  function SessionItemResultsList() {
    var _this2;
    _classCallCheck(this, SessionItemResultsList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, SessionItemResultsList, [].concat(args));
    _defineProperty(_this2, "renderSessionItem", function (sessionItem, shouldRenderTopBorder) {
      return jsx(SessionItemResult, {
        appContainer: _this2.props.appContainer,
        key: sessionItem.id,
        restrictQuantitativeData: _this2.props.restrictQuantitativeData,
        sessionItem: sessionItem,
        sessionItemResult: sessionItem.sessionItemResult,
        shouldRenderTopBorder: shouldRenderTopBorder
      });
    });
    _defineProperty(_this2, "renderItems", function () {
      return generateDisplayPositions(_this2.props.sessionItems).map(function (si) {
        return _this2.renderItem(si.record);
      });
    });
    return _this2;
  }
  _inherits(SessionItemResultsList, _Component);
  return _createClass(SessionItemResultsList, [{
    key: "renderItem",
    value: function renderItem(sessionItem) {
      if (sessionItem.isStimulus) {
        return jsx(ResultStimulus, {
          key: sessionItem.id,
          renderItem: this.renderSessionItem,
          stimulus: sessionItem.stimulusRecord,
          sessionItem: sessionItem
        });
      }
      return this.renderSessionItem(sessionItem, true);
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, jsx("div", {
        css: this.props.styles.sessionItemResultsListHeaderWrapper
      }, jsx("div", {
        css: this.props.styles.sessionItemResultsListHeader,
        "data-automation": "sdk-session-item-results-list-header"
      }, jsx(Heading, {
        level: "h2"
      }, t('Your Answers:')))), jsx("div", {
        css: this.props.styles.sessionItemResultsList
      }, this.renderItems()));
    }
  }]);
}(Component), _defineProperty(_SessionItemResultsList, "displayName", 'SessionItemResultsList'), _defineProperty(_SessionItemResultsList, "componentId", "Quizzes".concat(_SessionItemResultsList.displayName)), _defineProperty(_SessionItemResultsList, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  restrictQuantitativeData: PropTypes.bool,
  sessionItems: ImmutablePropTypes.list.isRequired,
  styles: PropTypes.object
}), _defineProperty(_SessionItemResultsList, "defaultProps", {
  restrictQuantitativeData: false
}), _SessionItemResultsList)) || _class);
export default SessionItemResultsList;